/**
 * Laadt Horizon-modules pas als hun custom element op de pagina verschijnt.
 *
 * snippets/scripts.liquid zet een JSON-lijst [["element-tag", "module-url"], ...] in
 * <script type="application/json" data-oppie-lazy-modules> voor elementen die niet
 * in de server-HTML van de pagina staan. Dit script kijkt of zo'n element toch al
 * in het document staat (header/footer-groep) en houdt daarna in de gaten of het
 * later verschijnt: winkelwagen-lade, quick add, zoekresultaten, Section Rendering
 * API (morph). Dan laadt het de module, die het element zelf definieert.
 */

function readModuleMap() {
  try {
    const el = document.querySelector('script[data-oppie-lazy-modules]');
    const pairs = el ? JSON.parse(el.textContent || '[]') : [];
    return Array.isArray(pairs) ? pairs : [];
  } catch (error) {
    console.error('[oppie-lazy-modules] invalid module map', error);
    return [];
  }
}

const pending = new Map(readModuleMap());
const loadedUrls = new Set();

function load(tag) {
  const url = pending.get(tag);
  pending.delete(tag);
  if (!url || loadedUrls.has(url)) return;
  loadedUrls.add(url);
  import(url).catch((error) => {
    loadedUrls.delete(url);
    console.error(`[oppie-lazy-modules] failed to load module for <${tag}>`, error);
  });
}

/** @param {ParentNode & Partial<Element>} root */
function scan(root) {
  for (const tag of Array.from(pending.keys())) {
    if (root.matches?.(tag) || root.querySelector(tag)) load(tag);
  }
}

if (pending.size > 0) {
  scan(document);

  if (pending.size > 0) {
    const observer = new MutationObserver((records) => {
      for (const record of records) {
        for (const node of record.addedNodes) {
          if (node.nodeType === Node.ELEMENT_NODE) scan(/** @type {Element} */ (node));
        }
        if (pending.size === 0) {
          observer.disconnect();
          return;
        }
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
}
